import axios from '../../axios'

// ** Function to get all states
const getAllCountry = async (params) => {
  const res = await axios.get(
    `/country`,
  )
  return res?.data
}


export { getAllCountry }
